import {
    TableViewStore,
    BaseListViewStore,
    BasicQueryCheckboxStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {PersonService} from 'application/person/services';
import {resolveColumns} from 'application/facility/util/resolveColumns';
import { GridBooleanCell } from 'core/components';
import { action } from 'mobx';
import _ from 'lodash';

@applicationContext
class PersonViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'person',
            autoInit: true,
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.person.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => 
                        i.id === item.id, 
                        () => item.firstName + ' ' + item.lastName
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.person.edit',
                        { id: item.id }
                    )
                },
                delete: async item => {
                   return await personService.delete({ id: item.id });
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await personService.find(_.extend(params, {
                            isActive: params.inactive == undefined || !params.inactive || params.inactive == 'false' ? true : null
                        }));
                        return response.data;
                    },
                    delete: async (item) => {
                        await personService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });

        this.service = personService;
        this.inactiveCheckboxStore = new BasicQueryCheckboxStore();

        this.queryUtility.onResetFilter = () => {
            this.inactiveCheckboxStore.reset();
        }

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                 {
                    key: 'firstName',
                    title: 'PERSON.LIST.COLUMNS.FIRST_NAME',
                    onClick: item => this.routes.edit(item)
                },
                 {
                    key: 'lastName',
                    title: 'PERSON.LIST.COLUMNS.LAST_NAME',
                    onClick: item => this.routes.edit(item)
                },
                {
                    key: 'initials',
                    title: 'PERSON.LIST.COLUMNS.INITIALS',
                    onClick: item => this.routes.edit(item)
                },
                {
                    key: 'email',
                    title: 'PERSON.LIST.COLUMNS.EMAIL',
                    onClick: item => this.routes.edit(item)
                },
                {
                    key: 'extension',
                    title: 'PERSON.LIST.COLUMNS.EXTENSION',
                    onClick: item => this.routes.edit(item)
                },
                {
                    key: 'isActive',
                    title: 'PERSON.LIST.COLUMNS.IS_ACTIVE',
                    onClick: item => this.routes.edit(item),
                    cell: GridBooleanCell,
                    displayFaultyValue: true,
                    headerClassName: 'center'
                }
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async(item) => this.onDelete(item)
            }
        }));
    } 
    @action.bound
    async onDelete(item) {
        this.rootStore.modalStore.showConfirm(
            'PERSON.LIST.COLUMNS.DELETE_MESSAGE',
            async () => {
                try{
                    var response = await this.routes.delete(item);
                    this.rootStore.notificationStore.success(response.statusCode === 204 ? 'Person made inactive.': response.statusCode === 200 ? 'Person successfully removed.' : 'An error ocurred while trying to delete person.');
                    this.queryUtility.fetch();
                }catch(err){
                    this.rootStore.notificationStore.error("An error ocurred while trying to delete Patient.");
                }
            }
        );
    }

    @action.bound
    oninactiveChange(event) {
        const value = event.target.checked;
        this.queryUtility.filter.toggle('inactive');
        this.inactiveCheckboxStore.setValue(value);
    }
}

export default PersonViewStore;
